// CUSTOM JS BY SATURDAY REPUBLIC

// Open links in new window

(function () {
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }  
})();

/* 
Klaviyo custom form open handlers 
- For this script to work, set any link URLs in the theme customizer sections/blocks
  to follow this convention: #klaviyo-form-[form ID] 
*/

// 1. Wait for page and all dependent resources such as scripts, stylesheets, and images, 
//    to load because custom form opening requires global Klaviyo JS to be loaded first.
window.addEventListener('load', (event) => {
  
  var _klOnsite = window._klOnsite || [];
  
  // 2. Get all link elements that have "#klaviyo-form-" in their href attribute 
  var customKlaviyoFormLinks = document.querySelectorAll('a[href*="klaviyo-form-"]');
  
  // 3. If there are any elements found, loop through them and set up the custom open handler
  if (customKlaviyoFormLinks.length) {
    for (let i = 0; i < customKlaviyoFormLinks.length; i++) {
      customKlaviyoFormLinks[i].addEventListener('click', e => {
        // 3.1 Prevent default link behavior on click
        e.preventDefault();
        
        // 3.2 open the Klaviyo form instead 
        _klOnsite.push(['openForm', e.target.href.split('-')[e.target.href.split('-').length - 1]]);  
      });
    }
  }
});

/* End Klaviyo custom form open handlers */